import React, { useState, useEffect } from "react";
import Loading from "../../../components/isLoading";
import MultiRecordsChartComponent from "../../components/stats/MultiRecordsChart";
import moment from "moment";
import NoContent from "../../../components/NoContent";
import { formatChartData } from "../../../helpers/formatChartData";
import { whiteColor } from "../../../assets/styles/base";
import MenuComponent from "../../../components/Menu";

export default (props) => {
  const { chartData, isUpdating, role, isDateRange, isEditor } = props;

  const [state, setState] = useState({
    activeMenuName: "Country",
    activeMenuIdentifier: "country",
    dataToDisplay: { data: {} },
    initialData: { data: {} },
  });

  const onMenuClose = (identifier) => {
    setState({
      ...state,
      activeMenuName: identifier.charAt(0).toUpperCase() + identifier.slice(1),
      activeMenuIdentifier: identifier.includes("device")
        ? "deviceCategory"
        : identifier,
    });
  };

  const menuList = ["Country", "Device Category", "Date"];

  useEffect(() => {
    if (chartData.country) {
      setState({
        ...state,
        initialData: {
          data: formatChartData(chartData, state.activeMenuIdentifier),
        },
        dataToDisplay: {
          data: formatChartData(chartData, state.activeMenuIdentifier),
        },
      });
    }
  }, [chartData, state.activeMenuIdentifier]);

  const showChosenData = (selectLabels) => {
    const selectLabelsArr = selectLabels.map((elt) => elt.label);
    const selectDatasetsArr = selectLabels.map((elt) => ({
      screenPageViews: elt.data.screenPageViews,
      sessions: elt.data.sessions,
    }));

    setState((prevState) => ({
      ...prevState,

      dataToDisplay: {
        data: {
          ...prevState.dataToDisplay.data,
          datasets: [
            {
              ...prevState.initialData.data.datasets[0],
              data: prevState.initialData.data.datasets[0].data
                .map((item, index) => {
                  const itemIsSelected = selectDatasetsArr.find(
                    (obj) => obj.screenPageViews === item
                  );

                  if (itemIsSelected) {
                    return item;
                  }
                })
                .filter((elt) => !!elt),
            },
            {
              ...prevState.initialData.data.datasets[1],
              data: prevState.initialData.data.datasets[1].data
                .map((item, index) => {
                  const itemIsSelected = selectDatasetsArr.find(
                    (obj) => obj.sessions === item
                  );

                  if (itemIsSelected) {
                    return item;
                  }
                })
                .filter((elt) => !!elt),
            },
          ],

          labels: prevState.initialData.data.labels
            .map((item) => {
              if (selectLabelsArr.includes(item)) {
                return item;
              }
            })
            .filter((elt) => !!elt),
        },
      },
    }));
  };

  return isUpdating ? (
    <Loading />
  ) : (
    <>
      {state.dataToDisplay.data.labels ? (
        <>
          <MenuComponent
            onMenuClose={onMenuClose}
            menuList={menuList}
            menuTitle={state.activeMenuName}
            showChosenData={showChosenData}
            data={state.initialData}
          />

          <MultiRecordsChartComponent
            data={
              state.dataToDisplay.data.labels[0]
                ? state.dataToDisplay.data
                : state.initialData.data
            }
            background={whiteColor}
            title={state.activeMenuName}
          />
        </>
      ) : (
        <NoContent title={"No Content ."} />
      )}
    </>
  );
};
